import React from 'react';

//https://react-select.com/home
import Select from 'react-select';

//options = [
//    { value: 'chocolate', label: 'Chocolate' },
//    { value: 'strawberry', label: 'Strawberry' },
//    { value: 'vanilla', label: 'Vanilla' }
//]

const Selectpicker = ( props ) => {
 return (
     <div className="selectpicker-container">
         {
             props.title && (
                <span className="title">{ props.title }</span>
             )
         }
         <Select
            {...props}
            noOptionsMessage={ () => "Nincs kiválasztható elem"}
        />
     </div>
 )
};

export default Selectpicker;